'use client';

import dynamic from 'next/dynamic';

const SVGDemo = dynamic(() => import('./index'));

export default SVGDemo;
